import React, { useContext, useEffect, useRef, useState } from "react";
import Footer from "../components/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser"
import { getDatabase, ref, get, set, update, remove } from "firebase/database";
import app from '../firebase/firebase.config';
import { getStorage, uploadBytesResumable, getDownloadURL, ref as refStorage } from 'firebase/storage'
import MailchimpSubscribe from "react-mailchimp-subscribe"

import { AuthContext } from "../context/UserContext";
// import SimpleHeader from "../components/SimpleHeader";
import HeroBackgroundImage from "../images/hero.jpg";

import jsonList from '../it.json'
import ResponsiveHeader from "../components/ResponsiveHeader";
import MobileMenu from "../components/MobileMenu";
import Spinner from "../components/Spinner";

const emailjs_service_id = "service_z64n7l2";
const emailjs_template_id  = "template_ccethtk";
const emailjs_public_key = "wLbn98CUofxMaZK7-"
const company_email = "https://italyhlg.it/grildu249weriw239dsj771"
const company_name = "HLG"

const whiteList = ['emanuele.agnese@indena.com', 'marco_agostini@accord-healthcare.com', 's.agrati@biorep.it', 'alessandro.airoldi@sandoz.com', 'alfonso.costanza@novartis.com', 'alberto.ardizzone@ntcpharma.com', 'amadorigiorgio@gmail.com', 'bbacci@fidiapharma.it', 'alessandro.badini.confalonieri@spcorp.com', 'g.balzani@e-pharma.com', 'evina.banci@zambongroup.com', 'm.barnabo@chiesi.com', 'g.basso@enlifeconsulting.com', 'ctbe@novozymes.com', 'pmbertacco@lampugnaifarmaceutici.it', 'bertin@labormar.com', 'luigi.biancardi@tdcare.it', 'Antonella.Bianchi@pfizer.com', 'fede.bi2@libero.it', 'bianchi.giorgio@tin.it;giorgio.bianchi@bsbinnovation.eu', 'carlo.bongiorni@sanofi.com', 'franco.boselli@recipharm.com', 'Enrico.Bovi@Pfizer.com;enrico.bovi@libero.it', 'bdl@polifarma.it', 'segreteria@gppitaly.it', 'fabio.brischetto@zambongroup.com', 'paolo.brivio@midas-pharma.com', 'r.cali@gppitaly.it', 'elisabetta.capezio@mylan.com;elisabetta.capezio@viatris.com', 'info@carbetmedica.com', 'valerio.cartoni@boehringer-ingelheim.com', 'pamela.carnielli@epharma.com', 'acasati@its.jnj.com', 'g.cassandro@moltenifarma.it', 'andc@brenta.net', 'M.castelnovo@sinerga.it', 'giulia.cattani@servier.com', 'laura.cattarini@mastelli.it', 'scavallotti@novaargentia.it', 'maurizio.cervo@infectopharma.com', 'francesco.cerri@angelinipharma.com', 'cesta@dompe.it', 'nmciccarello@drivegum.com;nazareno@functionalgums.com', 'antonella.cimatti@sofarfarm.it', 'domenico.chirico@sandoz.com', 'stefano.coco@3bfuture.com', 'colombo@oldpharma.it', 'elena.coloretti@dompe.com', 'console@strategicadvisory.ch', 'annalisa.coraducci@humanitasreserch.it', 'anna.costa@giellepi.it', 'mcottini@apotex.com', 'claudia.cotugno@novartis.com', 'lcozzi@its.jnj.com', 'sabrina.cremascoli@mundipharma.it,mirella.marinoni@mundipharma.it', 'stefano.deluigi@helsinn.com', 'roberto.deponti@3bfuture.com', 'Fabrizio.desimone@valereadvisory.com', 'sdelfiorentino@menarini.it', 'r.delgrosso@cibe-labs.com', 'francesco.delrosso@angelinipharma.com', 'stefano.denicolai@unipv.it', 'fdibiasio@rovi.com', 'a.egidio@angelini.it', 'francesca.dileo@sandoz.com', 'fdistefano@scmhealth.eu', 'dolciniclaudia@gmail.com', 'gdondi@progefarm.it', 'itsado@chr-hansen.com', 'stefano.fasola@brunofarmaceutici.it', 'favara.d@recordati.it', 'cristiana.felici@abiogen.it', 'ferlenga.p@recordati.com', 'silvia.ferlin@zentiva.com', 'p.ferracchiati@dicofarm.it', 'ferrari.s@Recordati.it', 'alessio@alfakjn.com', 'andrea.ferrari@mesiteia.it', 'corrado.ferti@gmail.com', 'vittorio.ferzetti@genericidoc.it', 'afiani.ida@fareva.com', 'marco.filippini@mundipharma.it,mirella.marinoni@mundipharma.it', 'bruno.finazzi@libero.it', 'enrica.fiorini@bayer.com', 'f.florio@sosepharm.com', 'giampaolo.fogliatto@accelera.org', 'eleonora.folco@nordicpharma.com', 'federico.franceschi@indena.com', 'w.frosecchi@angelini.it', 'gabrielle.gache@santen.com', 'gianluca_gala@merck.com', 'ernesto.gallone@takeda.com', 'egle.gedrimaite@sofarfarm.it', 'domenico.giannasso@nordicpharma.com', 'rocco.gilio@merck.com', 'nadia.girelli@sandoz.com', 'gispen@finefoods.it; acquist3@finefoods.it', 'nicola.giubellina@dishmangroup.com', 'francesco.giuliano@sifigroup.com', 'maria.goncharova@newfadem.it', 'm.graziola@e-pharma.com', 'massimo.grilli@alfasigma.it', 'lgrottola@ecupharma.it', 'angelo.guglielmotti@angelinipharma.com', 'giuseppe.gugliotta@genericidoc.it', 'CARLO.GUIDI@HOTMAIL.COM', 'hausermann.c@Recordati.it', 'f.innocenti@bioprojet-italia.com', 'rin@helsinn.com', 'fabiana.ippolito@abcfarmaceutici.it', 'gianluca.labbate@galileoresearch.it', 'f.laboranti@sit.farmaceutici.com', 'dario.lamperti@dompe.com', 'Olga.LamuaOlivar@luyepharma.eu', 'rlanzani@progefarm.it', 'leonardoalessandro@hotmail.com;aleonar7@its.jnj.com', 'stefano.liessi1@gmail.com', 'a.livieri@mitsui.com', 'giorgio.lorenzetti@sandoz.com', 'l.longo@kyowa.it', 's.lunati@sit-farmaceutici.com', 'lubrano.f@recordati.it', 'mariarita.luparini@ntcpharma.com', 'matteo@matteomacchi.com', 'a.maggioni@siit-it.com', 'imagri@fidiapharma.it', 'mahfoud.r@recordati.com', 'lmaidich@aboca.it', 'r.mancuso@fulton.it', 'f.mannelli@moltenifarma.it', 'elena.manniello@sandoz.com', 'daniele.maranza@tevaitalia.it', 'g.marin@nathura.com', 'marinich@marinich.eu', 'emarre@neuraxpharm.com', 'a.petricig@chiesi.com', 'a.marzano@medacpharma.it', 'pfmaschio@ricerchimica.com', 'marco.mastrodonato@bmgpharma.com', 'giovanni.mauri@ntcpharma.com', 'antonio.mazzeo@angelinipharma.com', 'mariagrazia.mazzone@sifigroup.com', 'fmazzott@its.jnj.com', 's.mazzuoccolo@italfarmacogroup.com', 'm.meazzini@neogen.it', 'marina.mele@angelinipharma.com', 'gmennella@egamid.com', 'lmeucci@fidiapharma.it', 'michelil@finefoods.it', 'milan.fabrizio57@gmail.com', 'marco.mochi@ntcpharma.com', 
'd.zilocchi@probiotical.com', 'lmonald@its.jnj.com', 'marco.montanari@prineos.com', 'eugenio.mora@angelinipharma.com', 'mattia.moretti@noosit.it', 'gm@n-trust.it', 'federico.motta@interhealthscience.it', 'marina.naccarato@sandoz.com', 'rosario.napoli@bausch.com', 'a.nardi@italfarmaco.com', 'monica.oneglio@adareps.com', 'francesca.orsini@indena.com', 'rocco.paracchini@adarepharma.com', 'j.pashako@emgi-srl.com', 'p.parlatore@medacpharma.it', 'anna.pasin@mesiteia.it', 'm.patrucco@probiotical.com', 'emanuela.pavese@geneticspa.it', 'teresa.maiellaro@geneticsspa.com', 'apellegrini@menarini.it', 'r.perriccioli@moltenifarma.it', 's.poce@esserrepharma.it', 'giorgio.pinci@merckserono.net', 'g.piras@srfarmaceutici.com', 'maria.pozzoli@sanofi.com', 'angelo.pizzoni@apharm.it;pizzoni.angelo@biofarmagroup.it', 'paolo.pizzoni@apharm.it', 'mpizzullo@aboca.it', 'lorenzo.pradella@bryetpharma.com', 'massimo.quattrini@ibsa.it', 'alfredo.quadrifoglio@valpharmagroup.com', 'm.radaelli@bluewin.ch', 'bruno.rago@ethypharm.com', 'silvia.rapacioli@bict.it', 're.sergio@alice.it', 'f.ricci@helmitalia.com', 'segreteriadirezione@farmadamor.it', 'c.rinaldi@petrone.it', 'paola.risi@sigma-tau.it', 'mrocchi@accord-healtcare.com', 'mroggero@lisapharma.it;marco_roggero@hotmail.com', 'lromagn@its.ini.com', 'dronchi@novaargentia.it', 'alessandro.rossi@jakinitaly.it', 'fulvia.rosso@boehringer-ingelheim.com', 'chiara.r1982@libero.it', 'cristiano.rumio@metishealthcare.com', 'sales1@mdesrl.com ', 'lasala@lisapharma.it', 'info@documedica.ch', 'info@documedica.ch', 'antonino.santoro@rottapharm.com', 's.sarno@fulton.it', 'fabrizio.savoldi@tillotts.com', 'a.scala@shedirpharmagroup.com', 'scali@oldpharma.it', 'd.sica@biorep.it', 'l.spampinato@mediolanum-farma.com', 'c.spelta@eglab.it', 'gianfranco.stamerra@grunenthal.com;eva.pinzella@grunenthal.com', 'elena.stucchi@astrazeneca.com', 'm.talaia@italfarmacogroup.com', 'carlo.terruzzi@giellepi.it', 'stefano.togni@indena.com', 'e.tommesani@chiesi.com;emanuela.tosi@gmail.com', 'gabriele_tundo@plexusventures.com', 'EUllo@aboca.it', 'a.affinito@essetifarmaceutici.it', 'valerio.valentini@infectopharma.com', 'info@anemocyte.com', 'paola.vella@humanitasresearch.it', 'roberto.verga@bict.it', 'staff@adv-ip.it;livia.villa@adv-ip.it', 'gvincenzi@lamp.it', 's.viti@bioprojet-italia.com', 'francesco.zambonin@geneticspa.com', 'aureliano@man-super.com', 'monica.dallolio1@gmail.com ', 'amadorigiorgio@gmail.com', 'mdellagrotta@fenicia.events', 'gabriele_tundo@plexusventures.com', 'm.mele@angelini.it', 'daniele.Maranza@tevaitalia.it'];

interface RegisterProps {
  status_mail: any,
  message: any,
  onValidated: Function
}

const Register:React.FC<RegisterProps> = ({ status_mail, message, onValidated }) => {
  const { createUser, logOut } = useContext(AuthContext);
  const [policyMessage, setPolicyMessage] = useState(false);
  const [errMessage, setErrMessage] = useState(false);
  const [genderMessage, setGenderMessage] = useState(false);
  const [registrationDone, setRegistraionDone] = useState(false); 
  const [portfolio, setPortfolio] = useState('')
  const [selectedFile, setSelectedFile] = useState<any>();
  const location = useLocation();
  const urlSearch = (new URLSearchParams(location.search));
  const [verifiedStatus, setVerifiedStatus] = useState<any>(undefined);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("Italia");
  const [selectedCompanyCountry, setSelectedCompanyCountry] = useState("Italia");
  const [fiscalCode, setFiscalCode] = useState('');
  const [isValidFiscalCode, setIsValidFiscalCode] = useState(true);
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [isValidDateOfBirth, setIsValidDateOfBirth] = useState(true);
  const [loading, setLoading] = useState(false);
  const [confirmedAlready, setConfirmedAlready] = useState(false);
  const [duplicateEmail, setDuplicateEmail] = useState(false);
  const [shortPasswordLength, setShortPasswordLength] = useState(false)
  const [matchPassword, setMatchPassword] = useState(true);
  const [error, setError] = useState();

  const email = urlSearch.get('email');
  const id = urlSearch.get('id');
  const status = urlSearch.get('status');
  const navigate = useNavigate();
  const refPortfolio = useRef<any>();
  const refGender = useRef<any>();


  const fiscalCodeRegExp = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;
  const refCPassword = useRef<any>(null);
  const refPassword = useRef<any>(null);

  const handleSelectPortfolio = () => {
    refPortfolio.current.click()
  }

  const handleFileChange = (e:any) => {
    const selectedFile = e.target.files[0];
    setSelectedFile(selectedFile);
    setPortfolio(URL.createObjectURL(selectedFile));
  }

  const handleFiscalCodeChange = (e:any) => {
    const inputFiscalCode = e.target.value;
    const isValid = fiscalCodeRegExp.test(inputFiscalCode);
    setIsValidFiscalCode(isValid);
    setFiscalCode(inputFiscalCode);
  };

  const handleDateChange = (e:any) => {
    let inputDate = e.target.value;

    // Remove non-numeric characters from input
    inputDate = inputDate.replace(/[^0-9]/g, '');

    // Add "/" after the 2nd and 4th character
    if (inputDate.length > 2) {
      inputDate = inputDate.slice(0, 2) + '/' + inputDate.slice(2);
    }
    if (inputDate.length > 5) {
      inputDate = inputDate.slice(0, 5) + '/' + inputDate.slice(5);
    }

    if (inputDate.length > 10) {
      inputDate = inputDate.slice(0, 10);
    }
    // Validate the date format
    const dateRegExp = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    const isValid = dateRegExp.test(inputDate);

    // Update state and validity
    setIsValidDateOfBirth(isValid);
    setDateOfBirth(inputDate);
  };

  const handleSelectCountry = (e:any) => {
    setSelectedCountry(e.target.value);
  }

  const handleSelectCompanyCountry = (e:any) => {
    setSelectedCompanyCountry(e.target.value);
  }

  const handleChangePolicyCheck = (e:any) => {
    if (e.target.value) {
      setPolicyMessage(false)
    }
  }

  useEffect(()=>{
    emailjs.init(emailjs_public_key);
    if(status==='confirm') {
      setLoading(true);
      setConfirmedAlready(false);
      const db = getDatabase();
      const tempUserRef = ref(db, `TempUsers/${id}`);
      console.log('temp id', id, tempUserRef)
      get(tempUserRef)
        .then((snapshot)=>{
          const userInfo = snapshot.val();
          if (userInfo) {
            createUser(userInfo.email, userInfo.password)
              .then((result: any) => {
                const user = result.user;
                const uid = user.uid;
                const userRef = ref(db, `users/${uid}`);
                const isVerifiedUser = whiteList.includes(user?.email);
                setVerifiedStatus(isVerifiedUser);
                set(userRef, {...userInfo, verified: isVerifiedUser, password: ""})
                  .then(()=>{
                    
                    // onValidated({
                    //   b_email: user?.email,
                    //   MERGE0: user?.email,
                    //   gdpr_36: true
                    // });
                      // const apiKey = "ca6e220e34ad995ae278eb2ce327a017-us22";
                      // const datacenter = apiKey.split("-")[1];
                      // const listId = "5ba848767e";
                      // const url = `https://${datacenter}.api.mailchimp.com/3.0/lists/${listId}/members`;
                      // const data = {
                      //   "email_address": email,
                      //   "status": "subscribed",
                      //   "merge_fields": {
                      //     "TAG": ["newsletter"] // Set the tag as a merge field
                      //   }
                      // };

                      // const options = {
                      //   method: "POST",
                      //   headers: {
                      //     "Authorization": `Basic ${btoa(`anystring:${apiKey}`)}`
                      //   },
                      //   body: JSON.stringify(data)
                      // };
                      // console.log("fetch mailchimp")
                      // fetch(url, options)
                      // .then(response => response.json())
                      // .then(data => {
                      //   // Handle successful subscription
                      //   console.log("Success! You're subscribed to the list.", data);
                      //   alert("Subscribed successfully!"); // You can replace this with a custom function
                      // })
                      // .catch(error => {
                      //   // Handle subscription error
                      //   console.error("Error subscribing to Mailchimp:", error);
                      //   alert("An error occurred. Please try again."); // You can replace this with a custom function
                      // });
                    remove(tempUserRef)
                      .then(()=>{
                        fetch(
                          "https://aquamarine-halva-e2e241.netlify.app/api/subscribe-user",
                          {
                              method: "OPTIONS",
                              headers: {
                              "Content-Type": "application/json",
                              },
                                  body: JSON.stringify({
                                  "email": user?.email,
                                  "name": userInfo?.name,
                                  "surName": userInfo?.surname,
                                  "newsletter": "Newsletter",
                                  "subscriber": "Subscriber"
                              }),
                              }
                          ).then(res=>{
                            console.log('res!!!', res)
                            fetch(
                              "https://hlg-server.vercel.app/mailtrap/subscribe",
                              {
                                method: "POST",
                                headers: {
                                  "Content-Type": "application/json",
                                },
                                body: 
                                  JSON.stringify({
                                    "email": user?.email,
                                    "name": userInfo?.name,
                                    "surname": userInfo?.surname,
                                    "manager_link": "https://italyhlg.it/super-manager"
                                  })
                              }
                            ).then(()=>{
                              console.log("subscribe success")
                            })
                            .catch((err)=>{
                              console.log('err here!', err);
                            })
                          }).catch((error)=>{
                            console.error('error!!!', error);
                          })
                        setLoading(false);
                      })
                      .catch((error)=>{
                        console.error(error);
                        setLoading(false);
                        setError(error);
                      })
                    if(isVerifiedUser) {
                      setLoading(false);
                      navigate(`/grildu249weriw239dsj771?status=verify&id=${uid}&email=${user.email}`);
                    }
                  })
                  .catch((error:any)=>{
                    setLoading(false);
                    setError(error);
                    console.error(error);
                  })
              })
              .catch((error: any) => {
                setLoading(false);
                setError(error);
                console.error(error);
              })
          } else {
            setLoading(false);
            setConfirmedAlready(true);
          }
        })
        .catch(error => {
          setLoading(false);
          setError(error);
          console.error('getuser', error);
        })
    }
    else if (status === 'verify') {
      const db = getDatabase();
      const userRef = ref(db, `users/${id}`);
      get(userRef)
      .then((snapshot)=>{
        const userInfo = snapshot.val();
        if (!userInfo) return;
        update(userRef, {
          verified: true
        })
        .then(()=>{

        })
        .catch((error)=>{
          console.log(error);
        })
      })
      .catch(error => {
          console.error('getuser', error);
      })
    }
  },[])

  const onClickLogin = () => {
    navigate('/login');
  }

  const onClickHandler = () => {
    setRegistraionDone(false);
    setPolicyMessage(false);
  }

  const generateRandomString = (length:any) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < length; i++) {
      randomString += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return randomString;
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const form = e.target;
    console.log(form["password"].value)
    if (form["password"].value.length<6) {
      setShortPasswordLength(true)
      refPassword?.current.focus()
      return;
    }
    setShortPasswordLength(false)
    if (form["password"].value!=form["cpassword"].value) {
      setMatchPassword(false);
      refCPassword?.current.focus();
      return;
    }
    setMatchPassword(true);
    if (!form["policy_agree"].checked) {
      setPolicyMessage(true);
      return;
    }

    if (form["gender"].value == "Sesso") {
      setGenderMessage(true);
      document.getElementById("gender")?.focus();
    }
    let portfolioUrl="";
    try {
      const storage = getStorage(app);
      const storageRef = refStorage(storage, `/portfolios/${selectedFile?.name}`);
      const uploadTask = uploadBytesResumable(storageRef, selectedFile);
      await new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            console.error(snapshot);
          },
          (err) => {
            console.error(err);
            reject(err);
          },
          async () => {
            try {
              const url = await getDownloadURL(uploadTask.snapshot.ref);
              console.error(url);
              portfolioUrl = url;
              resolve(true);
            } catch (error) {
              reject(error);
            }
          }
        );
      });
    } catch (error) {
      console.error("Error uploading portfolio:", error);
    }
    
    // generate the uid for the user 
    const cid = generateRandomString(10);

    // get the current Date
    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let currentDate = `${month}-${day}-${year}`;
    let hr = date.getHours();
    let mm = date.getMinutes();
    let sec = date.getSeconds();
    let currentTime = `${hr}:${mm}:${sec}`;
    // generate and save the confirm id which will be used in the confirmation link
    localStorage.setItem('cid', cid);
    const postData = {
      name: form["name"].value,
      surname: form["surname"].value,
      email: form["email"].value,
      password: form["password"].value,
      telephone: form["telephone"].value,
      linkedin: form["linkedin"].value,
      address: form["address"].value,
      cap: form["cap"].value,
      city: form["city"].value,
      province: form["province"].value,
      nation: form["nation"].value,
      tax_id: form["tax_id"].value,
      gender: form["gender"].value,
      city_of_birth: form["city_of_birth"].value,
      date_of_birth: form["date_of_birth"].value,
      agency: form["agency"].value,
      role: form["role"].value,
      company_postcode: form["company_postcode"].value,
      company_address: form["company_address"].value,
      company_city: form["company_city"].value,
      company_province: form["company_province"].value,
      company_nation: form["company_nation"].value,
      createdAt: currentDate,
      portfolio: portfolioUrl ?? '',
      company_logo_agree: form["company_logo_agree"].checked,
    }
    const email = form["email"].value;
    // save the unconfirmed user info
    const db = getDatabase();
    get(ref(db, "users/")).then((snapshot) => {
      if (snapshot.exists()) {
        const userData = snapshot.val();
        // Now you can work with the userData object containing all the users
        for (const userId in userData) {
          const userInfo = userData[userId];
          if(userInfo?.email==email) {
            setDuplicateEmail(true);
            return;
          }
        }
        get(ref(db, "TempUsers/")).then((tempSnapshot)=>{
          if (tempSnapshot.exists()) {
            const tempUser = tempSnapshot.val();
            for (const tempId in tempUser) {
              console.log("tempid", tempId)
              const tempUserInfo = tempUser[tempId];
              if (tempUserInfo?.email==email) {
                remove(ref(db,"TempUsers/"+tempId))
                .then(()=>{
                  console.log("removed the temp user,", tempId);
                })
                .catch((error)=>{
                  console.log(error)
                })
                ;
              }
            }
          }
        })
        set(ref(db, "TempUsers/" + cid), postData)
        .then(() => {
          //registration done flag to show the note for the registration
          setRegistraionDone(true);
          // send the confirm email
          emailjs.send(emailjs_service_id, emailjs_template_id,{
            from_name: company_name,
            message: `${company_email}?status=confirm&email=${form["email"].value}&id=${cid}`,
            to_email: form["email"].value,
            date: `${currentDate} ${currentTime}`,
            to_name: form["name"].value,
            publicKey: emailjs_public_key
            }).then(()=>{

            }).catch((error:any)=>{
              console.error(error)
            })
          form.reset();
          window.scrollTo(0,0);
        })
        .catch((error) => {
          console.error("setdata", error);
        });
      } else {
        console.log("No data available for the 'users' node");
      }
    }).catch((error) => {
      console.error("Error fetching users data:", error);
    });

    
  };
  
  const cityList = jsonList.cityList;
  const provinceList = jsonList.provinceList;
  const countryList = jsonList.countryList;

  return (
    <>
      {/* <section
        id="hero"
        className="bg-hero brightness-100 bg-no-repeat w-full bg-center bg-cover pt-80 pb-6 h-[40vh]"
      >
      </section>
      <SimpleHeader/> */}
      <ResponsiveHeader backgroundImage={HeroBackgroundImage} title="Registrazione" />
      <section>
        <div className="pb-[80px] md:pb-[200px]">
          <div className="grid grid-cols-1 md:grid-cols-5">
            <div className="hidden md:block col-span-2 pt-[100px] pl-[60px] md:pr-[20px] lg:pr-[60px]">
              <hr className="color-[#00a695] border border-[#00a695] w-4/5" />
              <div className="mt-[20px]">
                <strong>Hai bisogno di aiuto?</strong>
              </div>
              <a className="text-[#00a695]" href="">
                info@italyhlg.it
              </a>
              <p className="mt-[40px]">
                L 'iscrizione a Italy HLG permette di usufruire di:
              </p>
              <ul className="mt-[20px] pl-[40px] list-disc gap-[10px]">
                <li>
                  Ampie possibilità di Network con <strong>altri professionisti del
                  licensing e del business development</strong> di aziende e
                  organizzazioni nel settore Healthcare.
                  <strong>
                    altri professionisti del licensing e del business
                    development
                  </strong>
                  di aziende e organizzazioni nel settore Healthcare.
                </li>
                <li>
                  <strong>Accesso alla sezione riservata </strong>del sito.
                </li>
                <li>
                  Offre{" "}
                  <strong>partecipazione ad eventi di alta formazione </strong>
                  (BD Academy), godendo di condizioni economiche di favore
                  riservate agli associati.
                </li>
                <li>
                  Partecipazione ad altre
                  <strong> iniziative culturali e ricreative </strong>organizzate
                  dall'associazione con la finalità di
                  <strong> sviluppare il network.</strong>
                </li>
                <li>
                  Partecipazione ad{" "}
                  <strong>
                    eventi organizzati da IPLS International Partnering in
                    Lifescience Society e dalle altre associate EU.
                  </strong>
                </li>
                <li>
                  <strong>
                     Accesso alla Community Platform di IPLS, con inserimento di nominativo e profilo.
                  </strong>
                </li>
              </ul>
              <div className="mt-8">
                <a
                  className="text-[#125190] text-lg font-[700] underline"
                  href=""
                >
                  Per i nuovi iscritti
                </a>
              </div>
              <ul className="mt-[20px] pl-[40px] list-disc gap-[10px]">
                <li>
                  <strong>È necessario completare il form </strong>nei suoi campi obbligatori, ed una volta confermata via mail la richiesta, procedere al versamento della 
                  <strong> quota associativa </strong> (<span className="underline">€ 300</span> socio ordinario, <span className="underline">€ 0</span> socio onorario, <span className="underline">€ 200</span> 3° e 4° rappresentante di una stessa azienda, <span className="underline font-bold">€ 150</span> dal 4° rappresentante di una stessa azienda) tramite bonifico bancario o assegno non trasferibile alle seguenti coordinate:
                </li>
                <li>Italy HLG - Healthcare Licensing Group</li>
                <li>UniCredit Banca - Agenzia Milano Buonarroti</li>
                <li>Via Michelangelo Buonarroti 19 - 20149 Milano</li>
                <li>Codice IBAN IT 47 N 02008 01767 000100480153</li>
                <li>
                  Causale: Quota associativa 2025 + Nome Associato + Nome
                  Azienda
                </li>
              </ul>
              <h1 className="text-[17px] font-bold mt-6">
                L'iscrizione del nuovo associato diventa effettiva dopo
                l'approvazione da parte del consiglio direttivo.
              </h1>
              <div className="text-[17px] mt-6">
                Se preferisci fare la richiesta di iscrizione tradizionale, compila il  <a className="underline text-[#00a695]" href="/assets/domanda HLG Iscrizione 2025_domanda HLG Iscrizione.pdf" download="HLG-domanda-iscrizione-2024.pdf">modulo di iscrizione</a>
              </div>
            </div>

            <div id="" className="col-span-3 z-10 mt-[-120px]">
              <div id="form" className="z-50 bg-white md:p-24 pt-12 px-16">
                <div className="hidden md:block text-5xl text-[#0c2957] font-[700]">
                  <h1 className="mb-6">Iscrizione e</h1>
                  <h1>registrazione</h1>
                </div>
                { !loading && 
                  <p className="md:mt-6 font-bold md:font-[600]">
                    Unisciti alla community dei professionisti del licensing e del business development  del settore healthcare. Fare network. Un'opportunità per gli specialisti del Business Development.
                  </p> 
                }
                <a id="GoToForm" href="#form"></a>
                <a id="GoToGender" href="#gender"></a>
                {
                  registrationDone ? 
                  <div className="bg-[#e0f9fd] p-6 mt-6">
                    Grazie di esserti registrato! Ti abbiamo inviato una mail per confermare la tua registrazione.&nbsp; 
                    <span className="underline text-[#15818d] cursor-pointer" onClick={onClickHandler}>Invia di nuovo</span>
                  </div>
                  :
                  status === 'verify'? 
                    <div className="mt-5">
                      <div className="bg-[#e0f9fd] p-6 mt-6 text-center">
                        Il tuo account è confermato e ed è stato abilitato. Puoi effettuare il login ed accedere all'area riservata.
                        <button onClick={onClickLogin} className="uppercase bg-[#12357a] text-white w-full py-4 mt-4">login</button>
                      </div>
                    </div>
                    :
                    status === 'confirm'? 
                      <>
                        {loading && <div className="relative pt-16 flex flex-col items-center justify-content gap-8 text-sm w-3/5"><Spinner></Spinner><div>Attendere prego</div></div>}
                        {!loading && !confirmedAlready && <div className="bg-[#e0f9fd] p-6 mt-6">
                          Il tuo account è confermato! Il nostro team sta valutando la tua iscrizione per garantirti accesso. Grazie!
                        </div>}
                        {!loading && confirmedAlready && <div className="bg-[#e0f9fd] p-6 mt-6">
                        Questa e-mail è già stata confermata. Grazie
                        </div>}
                      </>
                      :
                      <form className="mt-6 w-full md:w-[80%]" onSubmit={handleSubmit}>
                      {errMessage && (
                        <h1 className="text-red-600 font-bold">
                          Registrazione non riuscita. Controlla che l'e-mail sia già
                          presente registrato o i dati non sono nuovamente corretti.
                        </h1>
                      )}
                      <input
                        id="name"
                        name="name"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        defaultValue=""
                        placeholder="Name"
                        required
                      />
                      <input
                        id="surname"
                        name="surname"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Cognome"
                        required
                      />
                      <input
                        id="email"
                        name="email"
                        className="block w-full p-5 my-4 border border-1"
                        type="email"
                        placeholder="E-mail"
                        required
                      />
                      <input
                        ref={refPassword}
                        name="password"
                        id="password"
                        className="block w-full p-5 my-4 border border-1"
                        type="password"
                        placeholder="Password"
                        required
                      />
                      {shortPasswordLength && (
                        <div className="text-red-600 text-lg mt-2">
                          La password deve contenere almeno 6 caratteri
                        </div>
                      )}
                      <input
                        ref={refCPassword}
                        id="cpassword"
                        name="cpassword"
                        className="block w-full p-5 my-4 border border-1"
                        type="password"
                        placeholder="Ripeti password"
                        required
                      />
                      {!matchPassword && (
                        <div className="text-red-600 text-lg mt-2">
                          Attenzione! Le password devono coincidere
                        </div>
                      )
                      }
                      <input
                        id="linkedin"
                        name="linkedin"
                        className="block w-full p-5 mb-4 mt-20 border border-1"
                        type="text"
                        placeholder="Linkedin address (es: linkedin.com/in/mariorossi)"
                      />
                      
                      <label htmlFor="portfolio" className="mt-20 text-sm text-gray-400">Aggiungi la tua foto</label>
                      <img src={portfolio} className="w-[80%]" alt="" />
                      <input onChange={ handleFileChange } accept="image/*" type="file" className="hidden" ref={refPortfolio}/>
                      <button onClick={ handleSelectPortfolio } className="text-center py-4 w-[80%] text-sm mt-2 border border-1">Scegli il file da caricare</button>
                      
                      <input
                        id="telephone"
                        name="telephone"
                        className="block w-full p-5 mb-4 mt-20 border border-1"
                        type="phone"
                        placeholder="Telefono"
                        required
                      />
                      <input
                        id="address"
                        name="address"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Indirizzo"
                        required
                      />
                      <input
                        id="cap"
                        name="cap"
                        className="block w-full p-5 my-4 border border-1"
                        type="number"
                        placeholder="CAP"
                        required
                      />
                      <select                         
                        id="nation"
                        name="nation"
                        className="block w-full p-5 my-4 border border-1"
                        placeholder="Nazione"
                        value={selectedCountry}
                        onChange={handleSelectCountry}
                        required
                      >
                        {/* <option value="">Nazione</option> */}
                        {
                          countryList.map((country) => (
                            <option key={country} value={country}>{country}</option>
                          ))
                        }
                      </select>
                      <input
                        id="city"
                        name="city"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Città"
                        required
                      />
                      {
                        selectedCountry === 'Italia' ?
                        <>
                          {/* <select                         
                            id="city"
                            name="city"
                            className="block w-full p-5 my-4 border border-1"
                            placeholder="Città"
                            required
                          >
                            <option value="">Città</option>
                            {
                              cityList.map((city) => (
                                <option key={city} value={city}>{city}</option>
                              ))
                            }
                          </select> */}
                          <select                         
                            id="province"
                            name="province"
                            className="block w-full p-5 my-4 border border-1"
                            placeholder="Provincia"
                            required
                          >
                            <option value="">Provincia</option>
                            {
                              provinceList.map((province) => (
                                <option key={province} value={province}>{province}</option>
                              ))
                            }
                          </select>
                        </>
                        :
                        <>
                          <input
                            id="province"
                            name="province"
                            className="block w-full p-5 my-4 border border-1"
                            type="text"
                            placeholder="Provincia"
                            required
                          />
                        </>
                      }
    
                      
                      {/* <input
                        id="nation"
                        name="nation"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Nazione"
                      /> */}
    
                      <input
                        id="tax_id"
                        name="tax_id"
                        className="block w-full p-5 my-4 mt-20 border border-1"
                        type="text"
                        placeholder="Codice Fiscale"
                        onChange={handleFiscalCodeChange}
                        required
                      />
                      <select
                        ref={refGender}
                        id="gender"
                        name="gender"
                        className="block w-full p-5 my-4 border border-1"
                        required
                      >
                        <option value="sesso">Sesso</option>
                        <option value="man">Maschio</option>
                        <option value="woman">Femmina</option>
                        <option value="woman">Preferisco non dire</option>
                      </select>
                      {genderMessage && (
                        <h1 className="text-red-600">
                          Per favore seleziona il tuo genere
                        </h1>
                      )}
                      <input
                        id="city_of_birth"
                        name="city_of_birth"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Città di nascita"
                        required
                      />
                      <input
                        id="date_of_birth"
                        name="date_of_birth"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        value={dateOfBirth}
                        onChange={handleDateChange}
                        placeholder="Data di nascita"
                        required
                      />
                      {!isValidDateOfBirth && <p className="text-red-600 text-xs">Inserire una data in formato gg/mm/aaaa</p>}
                      <input
                        id="agengy"
                        name="agency"
                        type="text"
                        className="block w-full p-5 my-4 mt-20 border border-1"
                        placeholder="Azienda"
                        required
                      />
                      <input
                        id="role"
                        name="role"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Ruolo"
                        required
                      />
                      <input
                        id="company_address"
                        name="company_address"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Indirizzo Azienda"
                        required
                      />
                      <input
                        id="company_postcode"
                        name="company_postcode"
                        className="block w-full p-5 my-4 border border-1"
                        type="number"
                        placeholder="CAP Azienda"
                        required
                      />
                      <select                         
                        id="company_nation"
                        name="company_nation"
                        className="block w-full p-5 my-4 border border-1"
                        placeholder="Nazione Azienda"
                        value={selectedCompanyCountry}
                        onChange={handleSelectCompanyCountry}
                        required
                      >
                        {/* <option value="">Nazione</option> */}
                        {
                          countryList.map((country) => (
                            <option key={country} value={country}>{country}</option>
                          ))
                        }
                      </select>
                      <input
                        id="company_city"
                        name="company_city"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Città Azienda"
                        required
                      />
                      {
                        selectedCompanyCountry === 'Italia' ?
                        <>
                          {/* <select                         
                            id="company_city"
                            name="company_city"
                            className="block w-full p-5 my-4 border border-1"
                            placeholder="Città Azienda"
                            required
                          >
                            <option value="">Città</option>
                            {
                              cityList.map((city) => (
                                <option key={city} value={city}>{city}</option>
                              ))
                            }
                          </select> */}
                          <select                         
                            id="company_province"
                            name="company_province"
                            className="block w-full p-5 my-4 border border-1"
                            placeholder="Provincia Azienda"
                            required
                          >
                            <option value="">Provincia</option>
                            {
                              provinceList.map((province) => (
                                <option key={province} value={province}>{province}</option>
                              ))
                            }
                          </select>
                        </>
                        :
                        <>
                          {/* <input
                            id="company_city"
                            name="company_city"
                            className="block w-full p-5 my-4 border border-1"
                            type="text"
                            placeholder="Città Azienda"
                            required
                          /> */}
                          <input
                            id="company_province"
                            name="company_province"
                            className="block w-full p-5 my-4 border border-1"
                            type="text"
                            placeholder="Provincia Azienda"
                            required
                          />
                        </>
                      }

                      <div className="mt-12 flex gap-2 text-sm">
                        <input
                          id="company_logo_agree"
                          name="company_logo_agree"
                          type="checkbox"
                          className="border-4 shadow border-gray-400 text-[24px] w-[15px] md:w-[20px] h-[20px]"
                        />
                        <div>
                          Acconsento a mostrare il logo della mia azienda sul sito web
                        </div>
                      </div>
                      <hr className="text-gray-500 mt-4" />
                      <div className="mt-4 mb-8 flex gap-2 text-sm">
                        <input
                          id="policy_agree"
                          name="policy_agree"
                          type="checkbox"
                          className="border-4 shadow border-gray-400 text-[24px] w-[15px] md:w-[20px] h-[20px]"
                          onChange={handleChangePolicyCheck}
                        />
                        <div>
                          {"   "}Accetto{" "}
                          <a className="underline" href="">
                            termini e condizioni della <a href="/privacy-policy">privacy</a>
                          </a>
                        </div>
                      </div>
                      {policyMessage && (
                        <div className="text-red-600 text-lg mt-2">
                           E' necessario accettare i termini e le condizione della <a href="/privacy-policy">privacy</a>
                        </div>
                      )}
                      {
                        duplicateEmail && (
                          <div className="text-red-600 text-lg mt-2">
                            Utente già registrato! Non è possibile completare la registrazione
                          </div>
                        )
                      }
                      <button
                        className="block w-full p-6 mt-8 mb-4 uppercase text-white text-xs bg-[#00a695]"
                        type="submit"
                      >
                        CONCLUDI LA REGISTRAZIONE
                      </button>
                      </form>
                 }
                
              </div>
            </div>
          </div>
        </div>
      </section>
      <MobileMenu/>
      <Footer/>
    </>
  );
}

const MailchimpRegister = () => {
  const url = `https://italyhlg.us22.list-manage.com/subscribe/post?u=245c1c35111c0766e4a980d04&id=5ba848767e`;

  return (
      <div className="mc__form-container">
          <MailchimpSubscribe
              url={url}
              render={({ subscribe, status, message }) => (
                  <Register
                      status_mail={status}
                      message={message}
                      onValidated={(formData:any) => subscribe(formData)}
                  />
              )}
          />
      </div>

  )
}

export default MailchimpRegister;
